import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild,
    ViewEncapsulation
} from "@angular/core";
import {Base} from "../../../../../../../../common/interfaces/base.interfaces";
import {Order} from "../../../../../../../../common/interfaces/order.interface";
import {Table2Component, TableCellSubscriber} from "../../../../../../../../common/components/table2";
import {Table} from "../../../../../../../../common/interfaces/table.interface";
import {Api, ApiService} from "../../../../../../../../common/services/api.service";
import {Modal, ModalService} from "../../../../../../../services/modal.service";
import {ToastService} from "../../../../../../../../common/services/toast.service";
import {UserService} from "../../../../../../../../common/services/user.service";
import {Router} from "@angular/router";
import {ConfirmComponent} from "../../../../../../../../common/components/confirm/confirm.component";
import {SpinnerService} from "../../../../../../../../common/services/spinner.service";
import {CommonFormComponent} from "../../../../../../../../common/components/form";
import {Api3Service} from "../../../../../../../../common/services/api3.service";
import {PusherService} from "../../../../../../../../common/services/pusher.service";
import {AppStateService} from "../../../../../../../../common/services/app-state.service";
import {PartnerService} from "../../../../../../../../common/services/partner.service";
import {
    CommonContextMenuComponent,
    IContextMenuOption
} from "../../../../../../../../common/components/context-menu/menu.component";


@Component({
    selector: "section-order-view-items-outbound",
    templateUrl: "items-outbound.component.html",
    styleUrls: [
        "../items.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})

export class OrderItemsOutboundComponent {

    public stockMode: string = "free";

    @Input()
    public state: Base.IState;

    @Input()
    public set order(orderData: Order.IOrderData) {
        if (orderData) {
            this.orderData = orderData;

            if (orderData.service_level) {
                if (orderData.service_level.properties) {
                    if (orderData.service_level.properties.stock_mode) {
                        this.stockMode = orderData.service_level.properties.stock_mode.toLowerCase();
                    }
                }
            }
            setTimeout(() => {
                this.prepareItemsLists();
            }, 50);
        }
    }

    public orderData: Order.IOrderData;

    @Input()
    public partmasters: any[] = [];

    @Output()
    public itemsUpdate: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    public canFindBySlug: EventEmitter<any> = new EventEmitter<boolean>();

    @Output()
    public onGenerateReport: EventEmitter<any> = new EventEmitter<boolean>();

    @Output()
    public action: EventEmitter<{ action: { name: string, data: any }, type: string }>
        = new EventEmitter<{ action: { name: string, data: any }, type: string }>();

    @ViewChild(Table2Component, {static: false})
    public outboundTable: Table2Component;

    @ViewChild(ConfirmComponent, {static: true})
    public confirmRef: ConfirmComponent;

    public outboundItemsList: Table.ISettings;
    public createOutboundShipment: boolean = false;

    public constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private apiService: ApiService,
        private api3Service: Api3Service,
        private modalService: ModalService,
        private toastService: ToastService,
        public router: Router,
        public userService: UserService,
        public spinnerService: SpinnerService,
    ) {
    }


    /**
     * Get property from user
     * @param {string} name
     * @param defaultValue
     * @returns {any}
     */
    private getProperty(name: string, defaultValue: any): any {
        return this.userService.getProperty(name, this.state, defaultValue);
    }

    /**
     * Get items
     * @returns {void}
     */
    private prepareItemsLists(): void {
        const contextOptions: IContextMenuOption[] = [];
        if (this.orderData.partner.id == 14) {
            contextOptions.push({
                name: "Shipment Customer Confirmation",
                value: "shipment_to_customer_confirmation"
            });
            contextOptions.push({
                name: "Replenishment Confirmation",
                value: "replenishment_confirmation"
            });
        }

        const columns: Table.ICol[] = [
            {
                data: "id",
                title: "",
                sortable: false,
                searchable: false,
                factory: {
                    component: CommonContextMenuComponent,
                    properties: {
                        options: contextOptions,
                        optionSelected: new TableCellSubscriber((row: any, event: any) => {
                            switch (event) {
                                case "shipment_to_customer_confirmation":
                                    this.sendShipmentCustomerConfirmation(row);
                                    break;
                                case "replenishment_confirmation":
                                    this.sendReplenishmentConfirmation(row);
                                    break;
                            }
                        })
                    }
                }
            },
            {
                data: "serial",
                title: "Serial number"
            },
            {
                data: "item",
                title: "Items",
                render: (row: any): string => {
                    return "<a class='tableAction' data-action='item'>" + row.item + "</a>";
                },
                click: (row: any) => {
                    this.actionHandler({name: "item", data: row}, row.type);
                },
            },
            {
                data: "part_master.description",
                name: "PartMaster.description",
                title: "Description",
                render: (row: any): string => {
                    if (row) {
                        if (row.part_master.description.length > 30) {
                            return `<span title="${row.part_master.description}">
                            ${row.part_master.description.substr(0, 30)}...</span>`;
                        } else {
                            return `<span>${row.part_master.description}</span>`;
                        }
                    } else {
                        return `<span>Missing description</span>`;
                    }
                }
            },
            {
                data: "price",
                title: "Price"
            },
            {
                data: "item",
                title: "",
                render: (row: any): string => {
                    if (row.inventory_allocations_sum_quantity > 0) {
                        return "<button class='mat-mdc-raised-button mdc-button mat-badge mat-badge-accent"
                            + " mat-badge-overlap mat-badge-above mat-badge-after mat-badge-medium' "
                            + "type='button'>"
                            + "<span class='mat-badge-content mat-badge-active'>"
                            + row.inventory_allocations_sum_quantity + "</span>"
                            + "Allocations"
                            + "</button>";
                    } else {
                        return "";
                    }
                },
                click: (row: any) => {
                    this.actionHandler({name: "allocations", data: row}, row.type);
                },
                searchable: false,
                sortable: false
            },
            {
                data: "item",
                title: "",
                render: (row: any): string => {
                    if (row.warehouse_transactions_sum_quantity > 0) {
                        return "<button class='mat-mdc-raised-button mdc-button mat-badge mat-badge-accent"
                            + " mat-badge-overlap mat-badge-above mat-badge-after mat-badge-medium status "
                            + ((row.status && row.status.name && row.status.name !== "")
                                ? row.status.name.toLowerCase() : "")
                            + "' "
                            + "type='button'>"
                            + "<span class='mat-badge-content mat-badge-active'>"
                            + row.warehouse_transactions_sum_quantity + "</span>"
                            + "Transactions"
                            + "</button>";
                    } else {
                        return "";
                    }
                },
                click: (row: any) => {
                    this.actionHandler({name: "transactions", data: row}, row.type);
                },
                searchable: false,
                sortable: false
            },
            {
                data: "batch",
                title: "Batch"
            },
            {
                data: "configurations",
                title: this.getProperty("configuration_name", "Configurations")
            },
            {
                data: "quantity",
                title: "Quantity"
            },
            {
                data: "inventory_conversion.customers_inventory_name",
                name: "InventoryConversion.customers_inventory_name",
                title: "Hub",
                render: (row: any): string => {
                    return row.inventory_conversion.customers_inventory_name
                        + " " + row.inventory_conversion.customers_sub_inventory;
                }
            },
            {
                data: "ref",
                title: "Ref",
                render: (row: any): string => {
                    return (row.ref ? row.ref + " " : "")
                        + "<mat-icon class='material-icons mat-icon pointer'>edit</mat-icon>";
                },
                click: (row: any): void => {
                    this.editParam(row.id, "ref", row.ref);
                }
            },
            {
                data: "ref2",
                title: "Ref2",
                render: (row: any): string => {
                    return (row.ref2 ? row.ref2 + " " : "")
                        + "<mat-icon class='material-icons mat-icon pointer'>edit</mat-icon>";
                },
                click: (row: any): void => {
                    this.editParam(row.id, "ref2", row.ref2);
                }
            },
            {
                data: "shipment.ref",
                name: "shipment.ref",
                title: "Shipment"
            },
            {
                data: "status.name",
                name: "Status.name",
                title: "Status"
            }
        ];

        if (this.state.section_slug === "annapurna_labs") {
            columns.push({
                data: "id",
                title: "Ref Logi",
            });
        }

        this.outboundItemsList = {
            // table_id: "jf8JnfivOdf",
            actions: [
                {
                    name: "edit",
                    title: "Edit",
                    click: (row: any) => {
                        this.actionHandler({name: "edit", data: row}, row.type);
                    },
                    disabledFn: (row: any): boolean => {
                        return row.allocation_in_progress ||
                            (this.orderData.confirmed
                                && !this.userService.validatePermissions("edit_order_item_after_confirmation"));
                    }
                },
                {
                    name: "allocate",
                    title: "Allocate",
                    click: (row: any) => {
                        this.allocateItem(row);
                        row.allocation_in_progress = true;
                    },
                    disabledFn: (row: any): boolean => {
                        return row.warehouse_transactions_sum_quantity
                            || Number(row.inventory_allocations_sum_quantity) === Number(row.quantity)
                            || row.allocation_in_progress;
                    },
                    cssClassFn: (row: any): string => {
                        return "mat-accent" + (row.allocation_in_progress ? " spin" : "");
                    },

                },
                {
                    name: "split",
                    title: "Split",
                    click: (row: any) => {
                        this.splitItem(row);
                    },
                    disabledFn: (row: any): boolean => {
                        return row.quantity == 1
                            || row.warehouse_transactions_sum_quantity > 0
                            || row.stock?.pallet?.length > 0
                            || row.stock?.box?.length > 0
                            || row.stock?.serial?.length > 0;
                    },
                },
                {
                    name: "delete",
                    title: "Delete",
                    click: (row: any) => {
                        this.actionHandler({name: "delete", data: row}, row.type);
                    },
                    disabledFn: (row: any): boolean => {
                        return row.warehouse_transactions_sum_quantity ||
                            (this.orderData.confirmed
                                && !this.userService.validatePermissions("edit_order_item_after_confirmation"));
                    }
                }
            ],
            api: {
                url: [
                    this.state.section,
                    "order-items",
                ],
                query: {
                    order_id: this.orderData.id,
                    type: "outbound",
                    relations: [
                        "PartMaster:id,description,default_quantity",
                        "InventoryConversion:id,customers_inventory_name,customers_sub_inventory",
                        "Status:id,name",
                        "Shipment:id,ref",
                    ],

                    relation_sum: {
                        "InventoryAllocations": "quantity",
                        "WarehouseTransactions": "quantity",
                    },
                    appends: [
                        "allocation_in_progress"
                    ]
                },
                version: 3
            },
            columns,
            search_default: ["item"],
            export: {
                file_name: "outbound items"
            },
            showTotal: true
        };

        this.changeDetectorRef.markForCheck();
    }

    private async editParam(order_item_id: number, field: string, old_value: any = null): Promise<any> {

        const {value}: Modal.IResponse = await this.modalService.open(CommonFormComponent, {
            formConfig: {
                id: 0,
                name: "Edit " + field,
                description: "",
                fields: [
                    {
                        label: "Value",
                        name: field,
                        size: "full",
                        type: "input",
                        required: true,
                    }
                ]
            },
            values: {
                [field]: old_value
            }
        });

        if (value && value[field]) {
            this.spinnerService.show();
            const {code, message}: Api.IResponse = await this.api3Service.patch(
                `${this.state.section}/order-items/${order_item_id}`, value);
            this.spinnerService.hide();

            if (code === 200) {
                this.toastService.show(message, "success");
                this.reload();
            }
        }
    }

    private async splitItem(item: any): Promise<any> {
        const split: Modal.IResponse = await this.modalService.open(CommonFormComponent, {
            modalWidth: "600px",
            formConfig: {
                name: "Split item",
                description:
                    "Warning! All existing allocations will be deleted.",
                fields: [
                    {
                        type: "filler",
                        size: "full margin-bottom-20"
                    },
                    {
                        label: "New item quantity",
                        name: "quantity",
                        size: "full",
                        type: "slider",
                        min: item.part_master.default_quantity,
                        max: item.quantity - item.part_master.default_quantity,
                        step: item.part_master.default_quantity,
                        values: [item.part_master.default_quantity],
                        required: true,
                    },
                ]
            },
            values: {
                quantity: item.part_master.default_quantity
            }
        });

        if (!split?.value?.quantity) {
            return;
        }

        this.spinnerService.show();
        const {message, code}: Api.IResponse = await this.api3Service.post(
            `${this.state.section}/order-items/${item.id}/split`, {
                quantity: split.value.quantity
            }
        );
        this.spinnerService.hide();
        if (code === 200) {

            this.toastService.show(message, "success");
            this.outboundTable.reload();
        }
    }

    private async sendShipmentCustomerConfirmation(row: any): Promise<any> {
        if (!await this.confirmRef.confirm("Resend file?")) {
            return;
        }

        this.spinnerService.show();
        const {code, message}: Api.IResponse = await this.api3Service.post(
            `${this.state.section}/order-items/${row.id}/shipment-customer-confirmation`);

        this.spinnerService.hide();
        if (code === 200) {
            this.toastService.show(message, "success");
        }
    }

    private async sendReplenishmentConfirmation(row: any): Promise<any> {
        if (!await this.confirmRef.confirm("Resend file?")) {
            return;
        }

        this.spinnerService.show();
        const {code, message}: Api.IResponse = await this.api3Service.post(
            `${this.state.section}/order-items/${row.id}/replenishment-confirmation`);

        this.spinnerService.hide();
        if (code === 200) {
            this.toastService.show(message, "success");
        }
    }

    public async allocateItem(item: any): Promise<any> {
        this.spinnerService.show();
        const {code, message}: Api.IResponse = await this.api3Service.post(
            `${this.state.section}/order-items/${item.id}/allocate`, {
                pallet: item.stock?.pallet,
                box: item.stock?.box,
                serial: item.stock?.serial,
            });

        this.spinnerService.hide();
        if (code === 200) {
            this.toastService.show(message, "success");
            this.reload(5000);
        }
    }

    public async allocateItems(): Promise<any> {
        this.spinnerService.show();
        const {code, message}: Api.IResponse = await this.api3Service.post(
            `${this.state.section}/orders/${this.orderData.id}/allocate`, {
                type: "outbound"
            });

        this.spinnerService.hide();
        if (code === 200) {
            this.toastService.show(message, "success");
            this.reload(5000);
        }
    }

    public reload(delay: number = 500): void {
        setTimeout(() => {
            this.outboundTable.reload();
        }, delay);
    }

    public actionHandler(action: { name: string, data: any }, type: string): void {
        this.action.emit({action, type});
    }

    public gotData(event: any, type: string): void {
        if (type === "outbound") {
            this.createOutboundShipment = event.hasData
                && (this.orderData.confirmed || this.state.section_slug == "annapurna_labs");
        }

        if (this.outboundTable && this.outboundTable.tableData.length !== 0) {
            this.canFindBySlug.emit(true);
        }
    }

}
